export default "__VITE_ASSET__DMivxgEv__"